import { useStateContext } from '@zambezi/caballo-vivo'
import classNames from 'classnames'
import React from 'react'

import NavBar, { NavItem } from './NavBar'
import PageTitle from './PageTitle'
import PaymentDetailItem from '@apiEnabler/ob-common/lib/view/PaymentDetailItem'
import DateTimeWarning from '@apiEnabler/ob-common/lib/view/DateTimeWarning'

import style from './LinkHistory.module.css'

export default function LinkHistory({ type, onCancelLink }) {
  const state = useStateContext()
  const selectedLink = state.getIn(['paymeyou', 'selectedLink'])
  const isReusable = selectedLink.get('isReusable')
  const isQR = selectedLink.get('isQR')
  const canCancelConsent = onCancelLink && selectedLink.get('isCancellable')

  return (
    <section className={classNames('zb-container js-pay-me-history')}>
      <NavBar
        items={[
          new NavItem({
            label: 'Pay Me / Pay You',
            link: `/paymeyou/${type}`,
          }),
        ]}
        padded
      />
      <header className={classNames(style.paymentHeader, 'js-header')}>
        <PageTitle
          consentType="payMeYou"
          status={selectedLink.get('friendlyGroup')}
          label={selectedLink.get('friendlyGroup')}
          showStatusIcon={true}
        />
      </header>
      <div className={`js-paymelink-details`}>
        <div className="zb-card">
          <div className={`zb-card-body js-history-item`}>
            <PaymentDetailItem
              label="Payee Name"
              value={selectedLink.get('payeeName')}
            />
            {!isReusable && !isQR && (
              <PaymentDetailItem
                label="Payer Name"
                value={selectedLink.get('payerName')}
              />
            )}
          </div>
          <div className={`zb-card-body js-history-item`}>
            {isReusable && (
              <PaymentDetailItem
                label={'Default payment value'}
                value={selectedLink.get('amountString')}
              />
            )}
            {!isReusable && (
              <PaymentDetailItem
                label={'Payment value'}
                value={selectedLink.get('amountString')}
              />
            )}

            <PaymentDetailItem
              label="Reference"
              value={selectedLink.get('reference')}
            />

            <PaymentDetailItem
              label="Payout ID"
              value={selectedLink.get('id')}
            />
            <PaymentDetailItem
              label="Request type"
              value={selectedLink.get('label')}
            />
          </div>
        </div>
      </div>
      <div className={`${style.history} js-paymelink-history`}>
        <h2 className={`${style.historyHeading} js-header`}>
          <span>History</span>
        </h2>
        <div className={`zb-card-body js-history-item`}>
          {!isReusable && (
            <PaymentDetailItem
              label="Link expiry"
              value={selectedLink.get('expiryDate')}
            />
          )}
          <PaymentDetailItem
            label="Link generated"
            value={selectedLink.get('dateText')}
          />
        </div>
        <DateTimeWarning />
      </div>
      {canCancelConsent && (
        <div className={style.cancelButton}>
          <button
            className={`zb-button zb-button-primary js-cancel-button`}
            onClick={() => onCancelLink(selectedLink)}
          >
            <span>Cancel payment request link</span>
          </button>
        </div>
      )}
    </section>
  )
}
